module.exports = __webpack_public_path__ + "static/media/westinchennai09.12d9772e.jpg";